import { cn } from '@/lib/cn';
import React from 'react';

interface CustomFieldHelperTextProps
  extends React.HTMLAttributes<HTMLParagraphElement> {
  error?: string;
  description?: string | null;
}

export const CustomFieldHelperText = React.forwardRef<
  HTMLParagraphElement,
  CustomFieldHelperTextProps
>(({ error, description, className, ...props }, ref) => {
  if (!description && !error) return null;

  return (
    <p
      ref={ref}
      className={cn(
        'mt-2 text-xs',
        error ? 'font-medium text-destructive' : 'text-muted-foreground',
        className
      )}
      role={error ? 'alert' : 'region'}
      aria-live='polite'
      {...props}
    >
      {error || description}
    </p>
  );
});

CustomFieldHelperText.displayName = 'CustomFieldHelperText';
